"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/radioButton/index.ts
var radioButton_exports = {};
__export(radioButton_exports, {
  RadioButton: () => RadioButton_default,
  RadioButtonsGroup: () => RadioButtonsGroup_default,
  default: () => RadioButton_default
});
module.exports = __toCommonJS(radioButton_exports);
var import_index2 = require("./index.css");

// src/radioButton/RadioButton.tsx
var import_classnames2 = __toESM(require("classnames"));
var import_react2 = require("react");

// src/common/constants/index.ts
var componentSizeToBodyTextSizeMap = {
  l: "body-one",
  m: "body-two",
  s: "body-three",
  xs: "body-four"
};

// src/typography/index.ts
var import_index = require("./index.css");

// src/typography/Typography.tsx
var import_classnames = __toESM(require("classnames"));
var import_react = require("react");

// ../component-library-styles/typography.module.scss
var typography_module_default = {
  "heading-xxl": "typography-module__heading-xxl___t4Iml",
  "heading-xl": "typography-module__heading-xl___wbMqr",
  "heading-lg": "typography-module__heading-lg___GUMI7",
  "heading-md": "typography-module__heading-md___I661h",
  "heading-sm": "typography-module__heading-sm___2Jm-k",
  "heading-xs": "typography-module__heading-xs___FJljd",
  "body-one": "typography-module__body-one___hKZXX",
  "body-two": "typography-module__body-two___Sa-Eb",
  "body-three": "typography-module__body-three___FIk3k",
  "body-four": "typography-module__body-four___vI1SQ",
  "overline-one": "typography-module__overline-one___rXzIm",
  "overline-two": "typography-module__overline-two___WG6bF",
  "overline-three": "typography-module__overline-three___UK5T-",
  "strong": "typography-module__strong___jtYq4",
  "extra-strong": "typography-module__extra-strong___9SBuV",
  "em": "typography-module__em___2kNMg",
  "figcaption": "typography-module__figcaption___cHscw",
  "no-margin": "typography-module__no-margin___dyDRA"
};

// src/typography/Typography.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Typography = ({
  semanticTag,
  visualAppearance,
  children,
  className,
  style,
  id,
  noMargin = false,
  ...props
}) => {
  const Tag = semanticTag;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    Tag,
    {
      id,
      className: (0, import_classnames.default)(
        typography_module_default[visualAppearance],
        noMargin && typography_module_default["no-margin"],
        className
      ),
      style,
      ...props,
      children
    }
  );
};
var Typography_default = (0, import_react.memo)(Typography);

// src/radioButton/radioButton.module.scss
var radioButton_module_default = {
  "radioButton": "radioButton-module__radioButton___1I0RM",
  "radioIcon": "radioButton-module__radioIcon___Zj5XP",
  "radioButtonLabel": "radioButton-module__radioButtonLabel___QJDES",
  "radioButton-l": "radioButton-module__radioButton-l___1I3wF",
  "radioButton-m": "radioButton-module__radioButton-m___camxE",
  "radioButton-s": "radioButton-module__radioButton-s___fKCA-",
  "radioButton-xs": "radioButton-module__radioButton-xs___-ZOJQ"
};

// src/radioButton/RadioButton.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var RadioButton = ({
  label,
  checked,
  onChange,
  name,
  value,
  disabled = false,
  size = "m",
  className,
  children
}) => {
  const bodyTextSize = componentSizeToBodyTextSizeMap[size];
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(
    "label",
    {
      className: (0, import_classnames2.default)(
        radioButton_module_default.radioButton,
        radioButton_module_default[`radioButton-${size}`],
        className
      ),
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
          "input",
          {
            type: "radio",
            name,
            value,
            checked,
            disabled,
            onChange
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("i", { className: radioButton_module_default.radioIcon }),
        label && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
          Typography_default,
          {
            semanticTag: "span",
            className: radioButton_module_default.radioButtonLabel,
            visualAppearance: bodyTextSize,
            children: label
          }
        ),
        children
      ]
    }
  );
};
var RadioButton_default = (0, import_react2.memo)(RadioButton);

// src/radioButton/RadioButtonsGroup.tsx
var import_classnames3 = __toESM(require("classnames"));
var import_react3 = require("react");
var import_jsx_runtime3 = require("react/jsx-runtime");
var RadioButtonsGroup = ({
  radioButtons,
  defaultValue = "",
  onChange,
  commonClassName
}) => {
  const [selectedValue, setSelectedValue] = (0, import_react3.useState)(defaultValue);
  const handleChange = (0, import_react3.useCallback)(
    (event) => {
      setSelectedValue(event.target.value);
      if (onChange) {
        onChange(event);
      }
    },
    [setSelectedValue, onChange]
  );
  const isSelectedButton = (0, import_react3.useCallback)(
    (value) => value === selectedValue,
    [selectedValue]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_jsx_runtime3.Fragment, { children: radioButtons.map((radioButtonProps) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
    RadioButton_default,
    {
      ...radioButtonProps,
      onChange: handleChange,
      checked: isSelectedButton(radioButtonProps.value),
      className: (0, import_classnames3.default)(commonClassName, radioButtonProps.className)
    },
    radioButtonProps.value
  )) });
};
var RadioButtonsGroup_default = RadioButtonsGroup;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  RadioButton,
  RadioButtonsGroup
});
//# sourceMappingURL=index.js.map